export class ConferencePlan {
    id: number;
    conferenceId: number;
    planLink: string;
    planFile: string;
    fileName: string;
}
